import { takeEvery, all, fork, put, call } from 'redux-saga/effects';
import { UserService } from '~/services';
import { Creators, Types } from '~/stores/ducks/cadastros/produtos/produtosGrupos';

function* fetchProdutosGrupos() {
  try {
    const response = yield call(
      () =>
        new Promise((resolve, reject) => {
          UserService.fetchGrupoProduto(resolve, reject);
        })
    );

    yield put(Creators.fetchProdutosGruposSuccess(response));
  } catch (error) {
    yield put(Creators.fetchProdutosGruposFailure(error));
  }
}

const watchProdutosGrupos = () =>
  function* watch() {
    yield takeEvery(Types.FETCH_PRODUTOS_GRUPOS, fetchProdutosGrupos);
  };

export default function* produtosGrupos() {
  yield all([fork(watchProdutosGrupos())]);
}
